export const announcements = {
  "announcements.create": "announcements.create",
  "announcements.setStatus": "announcements.setStatus",
  "announcements.edit": "announcements.edit",
  "announcements.get": "announcements.get",
} as const;
